export function getServiceTrackingUrl(): string {
  return "https://beacon.wikia-services.com/__track/special/";
}
